var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { ref: "component" }, [
    _vm.videoId
      ? _c("iframe", {
          attrs: {
            id: "existing-iframe-example",
            allowfullscreen: "",
            frameborder: "0",
            height: _vm.dataHeight,
            width: _vm.dataWidth,
            src:
              "//www.youtube.com/embed/" + _vm.videoId + "?enablejsapi=1&rel=0"
          }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-edd9d8b4", { render: render, staticRenderFns: staticRenderFns })
  }
}